@if (errorMessage) {
  <div class="error-message-container">
    <p class="error-message" data-testid="component-level-error-message">{{ errorMessage }}</p>
  </div>
}
